/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_GenericInputs */



/**
* | output |
* | --- |
* | "An error occurred. Please try again." |
*
* @param {Login_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_generic = /** @type {((inputs?: Login_Error_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur s'est produite. Veuillez réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un errore. Riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Произошла ошибка. Пожалуйста, попробуйте еще раз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha producido un error. Inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发生错误，请重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラーが発生しました。もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक त्रुटि हुई थी। कृपया दोबारा प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um erro. Tente novamente.")
	return /** @type {LocalizedString} */ ("An error occurred. Please try again.")
});